// extracted by mini-css-extract-plugin
export default {"sectionview":"sectionview_c085595505a2b35a2b0f","notice":"notice_dc2f314e6df1a51c8c63","icon":"icon_c9f2c8db99a4c224d699","body":"body_be267cb6198f9e19e6fe"};